export const saveFile = (blob, filename) => {
  const url = window.URL.createObjectURL(blob, {
    type: "application/octet-stream",
  });
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
    link.remove();
  }, 0);
};
